import React from 'react'
import PropTypes from 'prop-types'
import { getLanguageCode } from '../../../../../common/utils/translation-helper'
import { TEST_DISABLED_ACTIVATION_ON_BACKEND } from '../../../../../common/constants'
import styles from './footer.module.css'

const Footer = ({ intl, loadRawText, openCookiesModal }) => {
    const getCurrentYear = () => {
        const currentDate = new Date()
        return currentDate.getFullYear()
    }

    const urlParams = new URLSearchParams(window.location.search)
    const languageData = getLanguageCode(urlParams.get('locale'))

    const termsLangCode = languageData?.original?.toLowerCase()?.replace('-', '_')

    return (
        <div className={styles['footer-box']}>
            <footer className={styles['footer-container']}>
                <div className={styles['space']} />
                <div className={styles['footer-rights']}>
                    <div className={styles['footer-text']}>
                        <div className={styles['footer-rights-text']}>
                            {loadRawText(
                                <a
                                    href={`https://www.webfleet.com/${termsLangCode}/webfleet/legal/terms/`}
                                    target="_blank"
                                >
                                    {intl.translate('wf_footer_termsconditions')}
                                </a>,
                                'long'
                            )}{' '}
                            |
                            {loadRawText(
                                <a
                                    href={`https://www.webfleet.com/${termsLangCode}/webfleet/legal/copyright-notices/`}
                                    target="_blank"
                                >
                                    {intl.translate('wf_footer_copyrightnotices')}
                                </a>,
                                'long'
                            )}
                        </div>
                        <div className={styles['footer-rights-tttwf']}>
                            Copyright © 2006 - {getCurrentYear()} Bridgestone Mobility Solutions B.V. All rights
                            reserved.
                        </div>
                        {TEST_DISABLED_ACTIVATION_ON_BACKEND ? (
                            <div style={{ color: 'red' }}>
                                TEST MODE - ACTIVATION DISABLED ON BACKEND: Device activation will be blocked at last
                                step. If you want to disable this mode, set TEST_DISABLED_ACTIVATION_ON_BACKEND flag to
                                true.
                            </div>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
                <div className={styles['footer-cookies-settings']}>
                    <span onClick={openCookiesModal}>{loadRawText(intl.translate('ap_cookies_consent_settings'))}</span>
                </div>
                <div className={styles['footer-flag']} />
            </footer>
        </div>
    )
}

Footer.propTypes = {
    openCookiesModal: PropTypes.bool,
    intl: PropTypes.objectOf(PropTypes.func),
    loadRawText: PropTypes.func
}

export { Footer }
